import { theme as antdAlgorithms } from "antd";

/**
 * Ant Design token'ları — src/index.css'teki CSS değişkenleriyle aynı değerler.
 *
 * antd CSS değişkeni okuyamadığı için (token'lar JS'te hesaplanıp stil üretir)
 * hex'ler burada bir kez daha yazılır. index.css ile bu dosya BİRLİKTE
 * güncellenmeli.
 */

/** İki temada da aynı kalan marka/tipografi ayarları. */
const shared = {
  colorPrimary: "#e0a11c",
  fontFamily:
    "Inter, Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  fontSize: 13,
  controlHeight: 34,
  borderRadius: 8,
};

const PALETTE = {
  light: {
    colorInfo: "#2563eb",
    colorSuccess: "#16a34a",
    colorWarning: "#e0a11c",
    colorError: "#dc2626",
    colorTextBase: "#0d111a",
    colorBgBase: "#ffffff",
    colorBgLayout: "#f6f8fb",
    colorBorder: "#e4e9f0",
    colorBorderSecondary: "#eef2f7",
    boxShadowSecondary:
      "0 4px 12px rgba(16, 24, 40, 0.08), 0 1px 3px rgba(16, 24, 40, 0.06)",
    surface: "#ffffff",
    sunken: "#f6f8fb",
    hover: "#f6f8fb",
    headerText: "#36415a",
    tabIdle: "#5a6785",
    tabActive: "#0d111a",
    segmentedBg: "#0d111a",
    segmentedText: "#ffffff",
    tooltipBg: "#131926",
  },
  dark: {
    // Koyu zeminde doygun renkler bulanıyor — bir ton açılır.
    colorInfo: "#60a5fa",
    colorSuccess: "#22c55e",
    colorWarning: "#f1b634",
    colorError: "#f87171",
    colorTextBase: "#edf0f6",
    colorBgBase: "#131926", // ink-800 — kart yüzeyi
    colorBgLayout: "#080b12", // ink-950 — sayfa zemini
    colorBorder: "#252f43",
    colorBorderSecondary: "#1b2333",
    boxShadowSecondary:
      "0 4px 12px rgba(0, 0, 0, 0.45), 0 1px 3px rgba(0, 0, 0, 0.35)",
    surface: "#131926",
    sunken: "#0d111a",
    hover: "#1b2333",
    headerText: "#98a2b8",
    tabIdle: "#98a2b8",
    tabActive: "#edf0f6",
    segmentedBg: "#f1b634",
    segmentedText: "#0d111a",
    tooltipBg: "#1b2333",
  },
};

/** `mode`: "light" | "dark" */
export const buildAntdTheme = (mode = "light") => {
  const p = PALETTE[mode] ?? PALETTE.light;
  const isDark = mode === "dark";

  return {
    algorithm: isDark
      ? antdAlgorithms.darkAlgorithm
      : antdAlgorithms.defaultAlgorithm,
    token: {
      ...shared,
      colorInfo: p.colorInfo,
      colorSuccess: p.colorSuccess,
      colorWarning: p.colorWarning,
      colorError: p.colorError,
      colorTextBase: p.colorTextBase,
      colorBgBase: p.colorBgBase,
      colorBgLayout: p.colorBgLayout,
      colorBorder: p.colorBorder,
      colorBorderSecondary: p.colorBorderSecondary,
      boxShadowSecondary: p.boxShadowSecondary,
    },
    components: {
      Button: { fontWeight: 500, primaryShadow: "none", defaultShadow: "none" },
      Card: { headerFontSize: 14, colorBgContainer: p.surface },
      Table: {
        headerBg: p.sunken,
        headerColor: p.headerText,
        headerSortActiveBg: p.sunken,
        headerSortHoverBg: p.hover,
        headerFilterHoverBg: p.hover,
        headerSplitColor: p.colorBorder,
        rowHoverBg: p.hover,
        borderColor: p.colorBorderSecondary,
        colorBgContainer: p.surface,
      },
      Tabs: {
        itemColor: p.tabIdle,
        itemSelectedColor: p.tabActive,
        itemHoverColor: p.tabActive,
        inkBarColor: "#f1b634",
      },
      Modal: { borderRadiusLG: 12, contentBg: p.surface, headerBg: p.surface },
      Drawer: { colorBgElevated: p.surface },
      Segmented: {
        itemSelectedBg: p.segmentedBg,
        itemSelectedColor: p.segmentedText,
      },
      Tooltip: { colorBgSpotlight: p.tooltipBg },
    },
  };
};

export default buildAntdTheme;
